import { createApi } from "@reduxjs/toolkit/query/react";

import apiConfig from "configs/apiConfig";
import { REDUCER_PATHS } from "store/config";
import { transformResponseHandler } from "utils/transformResponseHandler";

import { customFetchBase } from ".";

const clubApi = createApi({
  reducerPath: REDUCER_PATHS.CLUBS,
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    clubListing: builder.query({
      query: (data) => ({
        url: apiConfig.CLUB_LISTING,
        body: data,
        method: "POST",
      }),
    }),
    clubAdminListing: builder.query({
      query: (data) => ({
        url: apiConfig.CLUB_ADMIN_LISTING,
        body: data,
        method: "POST",
      }),
    }),
    addClubs: builder.mutation({
      query: (data) => ({
        url: apiConfig.ADD_CLUBS,
        method: "POST",
        body: data,
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    clubsFileUplaod: builder.mutation({
      query: (data) => ({
        url: apiConfig.UPLOAD_CLUBS_FILE,
        body: data,
        method: "POST",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    clubsFileUplaodMini: builder.mutation({
      query: (data) => ({
        url: apiConfig.UPLOAD_CLUBS_FILE_MINI,
        body: data,
        method: "POST",
      }),
      //transformResponse: (resp) => transformResponseHandler(resp),
    }),
    clubsAdminsList: builder.mutation({
      query: (data) => ({
        url: apiConfig.CLUB_ADMINS_LIST,
        method: "POST",
        body: data,
      }),
    }),
    clubPostListing: builder.mutation({
      query: (data) => ({
        url: apiConfig.CLUB_POST_LIST,
        method: "POST",
        body: data,
      }),
    }),
    addClubPost: builder.mutation({
      query: (data) => ({
        url: apiConfig.ADD_CLUB_POST,
        method: "POST",
        body: data,
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    deleteClubPost: builder.mutation({
      query: (data) => ({
        url: apiConfig.DELETE_CLUB_POST,
        body: data,
        method: "DELETE",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    editClubPostDeatils: builder.mutation({
      query: (data) => ({
        url: apiConfig.EDIT_CLUB_POST + "/" + data?.id,
        body: {
          content: data.content,
          image: data?.image,
          featuredIcon: data.featuredIcon,
          status: data.status,
          taggedIds: data.taggedIds,
        },
        method: "PUT",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    clubPostFileUpload: builder.mutation({
      query: (data) => ({
        url: apiConfig.UPLOAD_CLUBS_POST_FILE,
        body: data,
        method: "POST",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    deleteClub: builder.mutation({
      query: (data) => ({
        url: apiConfig.DELETE_CLUB,
        body: data,
        method: "DELETE",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    updateClubStatus: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.UPDATE_CLUB_STATUS}/${data.id}`,
        body: data,
        method: "PUT",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    changeClubStatus: builder.mutation({
      query: (data) => ({
        url: apiConfig.CHANGE_CLUB_STATUS,
        body: data,
        method: "PATCH",
      }),
      invalidatesTags: ["clubDetails"],
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    clubDetailsDownload: builder.mutation({
      query: (data) => ({
        url: `${apiConfig.CLUB_DETAILS_DOWNLOAD}/${data.type}?languageId=${data?.languageId}&filter=${data.filter}&column=${data.column}`,
        method: "GET",
      }),
      // transformResponse: (resp) => transformResponseHandler(resp),
    }),
    addClubsWeek: builder.mutation({
      query: (data) => ({
        url: apiConfig.ADD_CLUBS_WEEK,
        method: "POST",
        body: data,
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    getClubTheBestDay: builder.mutation({
      query: (data) => ({
        url: apiConfig.GET_THE_BEST_DAYS,
        body: data,
        method: "POST",
      }),
    }),
    theBestDaysClubsData: builder.mutation({
      query: (id) => ({
        url: apiConfig.GET_THE_BEST_DAYS_DATA + "/" + id,
        method: "GET",
      }),
    }),
    editClubsProfile: builder.mutation({
      query: (data) => ({
        url: apiConfig.EDIT_CLUB_PROFILE + "/" + data?.id,
        method: "PUT",
        body: {
          clubFullName: data?.clubFullName,
          clubShortName: data?.clubShortName,
          description: data?.description,
          redemptionMethod: data?.redemptionMethod,
          thumbnailImage: data?.thumbnailImage,
          thumbnailImageMini: data?.thumbnailImageMini,
          coverImage: data?.coverImage,
          otherImages: data?.otherImages,
          capacity: data?.capacity,
          cityId: data?.cityId,
          zoneId: data?.zoneId,
          friendlyAddress: data?.friendlyAddress,
          postalCode: data?.postalCode,
          ticketBookingLink: data?.ticketBookingLink,
          instagramAccountLink: data?.instagramAccountLink,
          latitude: data?.latitude,
          longitude: data?.longitude,
          fullAddress: data?.fullAddress,
          googlePlaceId: data?.googlePlaceId,
          isPublished: data?.isPublished,
          status: data?.status,
          clubContactNumbers: data?.clubContactNumbers,
          clubTypes: data?.clubTypes,
          coverImageHorizontal: data?.coverImageHorizontal,
          isFourvenuesEnabled: data?.isFourvenuesEnabled,
          fourvenuesOrgId: data?.fourvenuesOrgId,
        },
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    getClubDetails: builder.mutation({
      query: (data) => ({
        url: apiConfig.CLUB_DETAILS + "/" + data?.id,
        method: "GET",
      }),
    }),
    clubsWeekListing: builder.mutation({
      query: (data) => ({
        url: apiConfig.CLUB_WEEK_LISTING,
        method: "POST",
        body: data,
      }),
      transformResponse: (resp) => {
        return {
          isMusicTypeError:
            resp?.data?.rows[0]?.clubWeeklyScheduleMusicTypeMappings?.length > 0
              ? true
              : false,
          isOutfitError:
            resp?.data?.rows[0]?.clubWeeklyScheduleOutfitMappings?.length > 0
              ? true
              : false,
          isPublished: resp?.data?.rows[0]?.isPublished || true,
          isOpen: resp?.data?.rows[0]?.isOpen || false,
          status: resp?.data?.rows[0]?.status || true,
          dayOfWeek: resp?.data?.rows[0]?.dayOfWeek || "",
          sessionName: resp?.data?.rows[0]?.sessionName || "",
          specialThing: resp?.data?.rows[0]?.specialThing || "",
          minAgeMale: resp?.data?.rows[0]?.minAgeMale || "",
          minAgeFemale: resp?.data?.rows[0]?.minAgeFemale || "",
          maxGeneralAge: resp?.data?.rows[0]?.maxGeneralAge || "",
          minGeneralAge: resp?.data?.rows[0]?.minGeneralAge || "",
          drinkPrice: resp?.data?.rows[0]?.drinkPrice || "",
          bottlePrice: resp?.data?.rows[0]?.bottlePrice || "",
          openingTime: resp?.data?.rows[0]?.openingTime || "",
          closingTime: resp?.data?.rows[0]?.closingTime || "",
          dj: resp?.data?.rows[0]?.dj?.map((dj) => ({ djName: dj })) || [
            { djName: "" },
          ],
          entryFeesRules: resp?.data?.rows[0]?.entryFeesRules?.map((rule) => ({
            entryFees: rule,
          })) || [{ entryFees: "" }],
          drinkPriceRules: resp?.data?.rows[0]?.drinkPriceRules?.map(
            (rule) => ({
              price: rule,
            })
          ) || [{ price: "" }],
          musicType:
            resp?.data?.rows[0]?.clubWeeklyScheduleMusicTypeMappings?.map(
              (o) => {
                return o?.musicTypeId;
              }
            ) || [],
          outFitType:
            resp?.data?.rows[0]?.clubWeeklyScheduleOutfitMappings?.map((o) => {
              return o?.outfitId;
            }) || [],

          weekDayId: resp?.data?.rows[0]?._id || null,
          isUpdated: false,
        };
      },
    }),
    clubsWeekDetailsListing: builder.mutation({
      query: (data) => ({
        url: apiConfig.CLUB_WEEK_LISTING,
        method: "POST",
        body: data,
      }),
    }),
    editClubsWeek: builder.mutation({
      query: (data) => ({
        url: apiConfig.EDIT_CLUBS_WEEK + "/" + data?.id,
        method: "PUT",
        body: {
          sessionName: data?.sessionName,
          specialThing: data?.specialThing,
          dj: data.dj,
          minAgeMale: data?.minAgeMale,
          minAgeFemale: data?.minAgeFemale,
          minGeneralAge: data?.minGeneralAge,
          maxGeneralAge: data?.maxGeneralAge,
          drinkPrice: data?.drinkPrice,
          bottlePrice: data?.bottlePrice,
          openingTime: data?.openingTime,
          closingTime: data?.closingTime,
          entryFeesRules: data.entryFeesRules,
          drinkPriceRules: data.drinkPriceRules,
          isPublished: data?.isPublished,
          isOpen: data.isOpen,
          status: data.status,
          musicTypes: data.musicTypes,
          outFits: data?.outFits,
        },
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),

    editMultiClubsWeek: builder.mutation({
      query: (data) => ({
        url: apiConfig.EDIT_MULTI_CLUBS_WEEK,
        method: "PUT",
        body: data,
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),

    clubsBenefitFileUplaod: builder.mutation({
      query: (data) => ({
        url: apiConfig.CLUB_BENEFITS_FILE_UPLOAD,
        body: data,
        method: "POST",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    addClubsBenefit: builder.mutation({
      query: (data) => ({
        url: apiConfig.ADD_CLUB_BENEFITS,
        body: data,
        method: "POST",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    getClubweekBenefits: builder.mutation({
      query: (data) => ({
        url: apiConfig.GET_WEEK_BENEFITES_LISTING + "/" + data.clubId,
        method: "GET",
      }),
    }),
    saveClubBenefitsData: builder.mutation({
      query: (data) => ({
        url: apiConfig.ADD_CLUB_BENEFITS_DATA,
        body: data,
        method: "POST",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    getClubBenefitActionPoints: builder.mutation({
      query: (data) => ({
        url: apiConfig?.CLUB_BENEFITS_ACTION_POINTS + "/" + data?.id,
        method: "GET",
      }),
    }),
    getClubBenefitSavedData: builder.mutation({
      query: (data) => ({
        url: apiConfig?.CLUB_BENEFIT_LISTING_EDIT + "/" + data?.id,
        method: "GET",
      }),
    }),
    clubLevelBenefitList: builder.mutation({
      query: (data) => ({
        url: apiConfig?.CLUB_LEVEL_BENEFIT_LIST + "/" + data?.id,
        method: "GET",
      }),
    }),
    clubMarkTheBest: builder.mutation({
      query: (data) => ({
        url: apiConfig.CLUB_MARK_BEST,
        body: data,
        method: "PATCH",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    addClubFalseVoy: builder.mutation({
      query: (data) => ({
        url: apiConfig.ADD_CLUB_FALSE_VOY,
        body: data,
        method: "post",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    addUpdateClubFalseVoy: builder.mutation({
      query: (data) => ({
        url: apiConfig.ADD_UPDATE_CLUB_FALSE_VOY,
        body: data,
        method: "post",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    editClubFalseVoy: builder.mutation({
      query: (data) => ({
        url: apiConfig.EDIT_CLUB_FALSE_VOY + "/" + data?.id,
        body: {
          falseVoys: data?.falseVoys,
          increaseStartTime: data.increaseStartTime,
          status: data.status,
          decreaseStartTime: data.decreaseStartTime,
        },
        method: "put",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    getClubUserStats: builder.mutation({
      query: (data) => ({
        url: apiConfig.CLUB_USERS_STATES + "/" + data?.id,
        method: "GET",
      }),
    }),
    getClubTopUser: builder.mutation({
      query: (data) => ({
        url: apiConfig.CLUB_TOP_USERS + "/" + data?.id + "/" + data.userCount,
        method: "GET",
      }),
    }),
    getClubLevelWiseUser: builder.mutation({
      query: (data) => ({
        url:
          apiConfig.CLUB_LEVEL_WISE_USERS + "/" + data?.id + "/" + data.level,
        method: "GET",
      }),
    }),
    getClubNameDropdown: builder.mutation({
      query: () => ({
        url: apiConfig.CLUB_NAME_DROPDOWN,
        method: "GET",
      }),
    }),
    getclubAdminClubsList: builder.mutation({
      query: () => ({
        url: apiConfig.CLUB_ADMIN_CLUBS_LIST,
        method: "GET",
      }),
    }),
    getClubAdminClubNames: builder.mutation({
      query: () => ({
        url: apiConfig.CLUBADMIN_CLUB_NAME_LIST,
        method: "GET",
      }),
    }),
    getClubCoOwnerEmail: builder.mutation({
      query: (data) => ({
        url: apiConfig.GET_NEW_CLUB_CO_OWNER_EMAIL + "/" + data,
        method: "GET",
      }),
    }),
    addClubNewCoOwner: builder.mutation({
      query: (data) => ({
        url: apiConfig.ADD_NEW_CLUB_CO_OWNER_EMAIL,
        body: data,
        method: "POST",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
    deleteClubCoOwner: builder.mutation({
      query: (data) => ({
        url: apiConfig.DELETE_CLUB_CO_OWNER + "/" + data?.id,
        body: data,
        method: "DELETE",
      }),
      transformResponse: (resp) => transformResponseHandler(resp),
    }),
  }),
});

export const {
  useGetClubCoOwnerEmailMutation,
  useAddClubNewCoOwnerMutation,
  useGetClubAdminClubNamesMutation,
  useGetclubAdminClubsListMutation,
  useGetClubNameDropdownMutation,
  useGetClubUserStatsMutation,
  useGetClubTopUserMutation,
  useGetClubLevelWiseUserMutation,
  useAddClubFalseVoyMutation,
  useEditClubFalseVoyMutation,
  useAddUpdateClubFalseVoyMutation,
  useClubMarkTheBestMutation,
  useClubLevelBenefitListMutation,
  useGetClubBenefitSavedDataMutation,
  useGetClubBenefitActionPointsMutation,
  useSaveClubBenefitsDataMutation,
  useGetClubweekBenefitsMutation,
  useAddClubsBenefitMutation,
  useClubsWeekListingMutation,
  useClubsWeekDetailsListingMutation,
  useAddClubsWeekMutation,
  useAddClubsMutation,
  useLazyClubListingQuery,
  useLazyClubAdminListingQuery,
  useDeleteClubMutation,
  useUpdateClubStatusMutation,
  useChangeClubStatusMutation,
  useClubDetailsDownloadMutation,
  useClubsFileUplaodMutation,
  useClubsFileUplaodMiniMutation,
  useClubsAdminsListMutation,
  useClubPostListingMutation,
  useAddClubPostMutation,
  useDeleteClubPostMutation,
  useEditClubPostDeatilsMutation,
  useClubPostFileUploadMutation,
  useEditClubsProfileMutation,
  useEditMultiClubsWeekMutation,
  useGetClubDetailsMutation,
  useEditClubsWeekMutation,
  useClubsBenefitFileUplaodMutation,
  useGetClubTheBestDayMutation,
  useTheBestDaysClubsDataMutation,
  useDeleteClubCoOwnerMutation,
} = clubApi;

export default clubApi;
